import React from 'react'

import { CloudBillingPlanFragment } from '@sketch/gql-types'

// This is a valid use case to narrow down Component type
// eslint-disable-next-line no-restricted-imports
import { Currency as CurrencyType } from '@sketch/gql-types/expansive'

import PlanPickerCard from '../../components/PlanPickerCard'
import {
  CurrentPlan,
  PlanWrapper,
  Wrapper,
} from './ChangeBillingPlanPicker.styles'

interface ChangeBillingPlanPickerProps {
  customerCurrency: CurrencyType
  selectedPlan?: CloudBillingPlanFragment
  currentPlan?: CloudBillingPlanFragment
  plans: CloudBillingPlanFragment[]
  onChange: (clickedPlan: CloudBillingPlanFragment) => void
}

const MONTHLY_TO_TITLE = {
  MONTHLY: 'Monthly',
  YEARLY: 'Yearly',
  TRIAL: 'Trial',
} as const

/**
 * This component is an adaptation of PlanPicker component.
 * We decided to "copy" the component because it has a few things different
 * from the original implementation and as this modal isn't the final
 * solution (we plan to have a single flow instead of this modal to change
 * the current plan) it makes no sense to spend time modifying the component
 * to make it flexible.
 * If for some reason we decided to keep this component instead of going for
 * a single flow, don't forget "merge" this component with PlanPicker.
 */
export const ChangeBillingPlanPicker: React.FC<
  ChangeBillingPlanPickerProps
> = ({ customerCurrency, onChange, plans, selectedPlan, currentPlan }) => {
  const selectPlanId = (selectedPlan || currentPlan)?.id

  return (
    <Wrapper>
      {plans.map(plan => (
        <PlanWrapper key={plan.id}>
          <PlanPickerCard
            plan={plan}
            isSelected={plan.id === selectPlanId}
            onChange={() => onChange(plan)}
            formatContent={plan => ({
              title: MONTHLY_TO_TITLE[plan.type],
              description: 'per Editor',
              price:
                plan.prices.find(price => price.currency === customerCurrency)
                  ?.invoice || 0,
              currency: customerCurrency,
              testId: plan.id,
            })}
          />

          {plan.id === currentPlan?.id && (
            <CurrentPlan>Current Plan</CurrentPlan>
          )}
        </PlanWrapper>
      ))}
    </Wrapper>
  )
}
